import { createHashRouter, RouterProvider } from "react-router-dom";
import HomePage from "../pages/HomePage";
import LoginPage from "../pages/LoginPage";
import Layout from "../pages/Layout";
import MandatePage from "../pages/MandateCheckout/MandateCheckout";
import PaymentTypeSelectPage from "../pages/PaymentTypeSelect";
import SwaggerDoc from "../pages/SwaggerDoc";
import ZohoAuth from "../pages/ZohoAuth";

const router = createHashRouter([
  {
    path: "/",
    element: <Layout />,
  },
  {
    path: "/home",
    element: <HomePage />,
  },
  {
    path: "/app",
    element: <Layout />,
  },

  {
    path: "/app/index.html",
    element: <HomePage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/mandate/:reference_id",
    element: <MandatePage />,
  },
  {
    path: "/payment-type/:reference_id",
    element: <PaymentTypeSelectPage />,
  },
  {
    path: "/swagger-documentation",
    element: <SwaggerDoc />,
  },
  {
    path:"/zoho-auth",
    element: <ZohoAuth />
  }
]);

export function Router() {
  return <RouterProvider router={router} />;
}
